import React from "react";

const TableauEmprunts = () => {
  return (
    <div className="tableau-emprunts">
      <h2>Tableau d’emprunts</h2>
      <p>Calendrier et détails des emprunts.</p>
    </div>
  );
};

export default TableauEmprunts;
